import { call, put, select, takeEvery } from "redux-saga/effects";
import {
    initTutorialsAction,
    loadTutorialsListAction,
    loadTutorialsListFailure,
    loadTutorialsListSuccess,
    setIsTutorialsInitedAction,
    updateTutorialItemAction,
    updateTutorialSeenAction,
    updateTutorialSeenFailure,
} from "./tutorialsReducer";
import { failurePut } from "../../app/failurePut";
import { getRequest, postRequest } from "../../app/request";
import { ITutorial, IUpdateTutorialSeenPayload } from "./tutorials.t";
import { isEnabledByFeatureAndAbTestSaga } from "../../app/appSagas";
import { FEATURES } from "../../app/appConstants";
import { AB_TESTS_NAMES } from "../AbTests/abTestsConstants";
import { getIsTutorialsInitedSelector } from "./tutorialsSelectors";
import { getUserHasLiveAccount } from "../../app/appSelectors";

export function* checkIsTutorialsAvailableSaga() {
    const hasLiveAccount = yield select(getUserHasLiveAccount);
    if (!hasLiveAccount) {
        return false;
    }
    return yield call(isEnabledByFeatureAndAbTestSaga, {
        payload: { feature: FEATURES.TUTORIALS, abTest: AB_TESTS_NAMES.TUTORIALS }
    });
}

function* loadTutorialsListSaga() {
    try {
        const isTutorialsAvailable = yield call(checkIsTutorialsAvailableSaga);
        if (!isTutorialsAvailable) {
            yield put(loadTutorialsListSuccess([]));
            return;
        }
        const data: ITutorial[] = yield call(getRequest, '/user/tutorials');
        yield put(loadTutorialsListSuccess(data));
    } catch (e) {
        yield call(failurePut, e, loadTutorialsListFailure);
    }
}

function* updateTutorialSeenSaga({ payload }: { payload: IUpdateTutorialSeenPayload }) {
    try {
        const updatedTutorial: ITutorial = yield call(postRequest, `/user/tutorials/${payload}/seen`);
        yield put(updateTutorialItemAction(updatedTutorial));
    } catch (e) {
        yield call(failurePut, e, updateTutorialSeenFailure);
    }
}

function* initTutorialsSaga() {
    const isInited = yield select(getIsTutorialsInitedSelector);
    if (isInited) return;
    yield put(setIsTutorialsInitedAction(true));

    const isTutorialsAvailable = yield call(checkIsTutorialsAvailableSaga);
    if (!isTutorialsAvailable) return;

    yield put(loadTutorialsListAction());
}

export function* tutorialsSagas() {
    yield takeEvery(initTutorialsAction, initTutorialsSaga);
    yield takeEvery(loadTutorialsListAction, loadTutorialsListSaga);
    yield takeEvery(updateTutorialSeenAction, updateTutorialSeenSaga);
}
